import { render, staticRenderFns } from "./InterestAndComment.vue?vue&type=template&id=9f42deb8&scoped=true&"
import script from "./InterestAndComment.vue?vue&type=script&lang=js&"
export * from "./InterestAndComment.vue?vue&type=script&lang=js&"
import style0 from "./InterestAndComment.vue?vue&type=style&index=0&id=9f42deb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f42deb8",
  null
  
)

export default component.exports